export const VPC = 'VPC';
export const MENTAL_HEALTH = 'BEHAVHEALTH';
